var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-group row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("general.cashflow_calculation"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-field" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.currency) } }),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.invoiceTotal / 100) },
            }),
            _vm._v("-"),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.currency) } }),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.withholding_tax_rate) },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c(
          "base-button",
          {
            staticClass: "mr-3",
            attrs: { outline: true, color: "theme", type: "button" },
            on: { click: _vm.closeCashFlowValueInvoiceModal },
          },
          [_vm._v("\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }